import ShareClasses from './share-classes';

export default ShareClasses;
